import LazyLoad from "vanilla-lazyload";

var myLazyLoad = new LazyLoad({
    elements_selector: ".lazy"
});


// WEBPACK FOOTER //
// ./scripts/components/lazy.js